import React from 'react'
import { TextInput } from '@common/material'
import { localizedStrings } from '@core/strings'
import { RegisterItemPropertyFormItemProps } from '@modules/registers/items/form/types'
import { Controller, useFormContext } from 'react-hook-form'

export const RegisterItemStringPropertyFormItem: React.FC<
  RegisterItemPropertyFormItemProps
> = ({ property, registerItem, sx, disabled }) => {
  const { control } = useFormContext()

  const isDisabled =
    disabled || (!!registerItem && property.lockedAfterCreation)

  return (
    <Controller
      name={`${property.id}`}
      control={control}
      rules={{
        validate: (value) => !!value?.textValue || !property.required,
      }}
      render={({ field, fieldState: { error } }) => (
        <TextInput
          key={property.id}
          value={field.value?.textValue || ''}
          data-test={`${property.type}-${property.name}`}
          inputProps={{
            'data-test': `${property.type}-${property.name}-input`,
          }}
          onChange={(e) =>
            field.onChange({
              ...property,
              registerPropertyId: property.id,
              textValue: e.target.value,
            })
          }
          disabled={isDisabled}
          multiline={true}
          sx={{
            mb: 2,
            flexGrow: 1,
            ...sx,
          }}
          required={property.required}
          label={property.name}
          placeholder={localizedStrings.typeHere}
          InputLabelProps={{ shrink: true }}
          error={!!error}
        />
      )}
    />
  )
}
